import { render, staticRenderFns } from "./ProspectManagement.vue?vue&type=template&id=758ac8b4&"
import script from "./ProspectManagement.vue?vue&type=script&lang=js&"
export * from "./ProspectManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports